const initialState = false ;

function cartId(state = initialState, action){
    switch(action.type){
        
        case 'CART_ID' : 
            state = action.data;
            return state;
       
        default : return state;

    }

}

export default cartId;